// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { ImageLargeFragmentDoc } from '../../../components/cms/imageLarge.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../components/cms/imageSize.fragment.generated';
export const PaymentIconFragmentDoc = `
    fragment paymentIcon on PaymentIcon {
  name
  icon {
    ...imageLarge
  }
}
    `;